export default "__VITE_ASSET__B3py7tVJ__"